// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as React from "react";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as AdLayout from "../app-core/AdLayout.bs.js";
import * as SupTraits from "../set-update/SupTraits.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as TraitInfoCard from "./TraitInfoCard.bs.js";
import * as InfoSectionHeader from "./InfoSectionHeader.bs.js";

var traitsGrid = "grid gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xxl:grid-cols-4";

var Styles = {
  traitsGrid: traitsGrid
};

function TraitsInfoPage$Inner(Props) {
  var set = TftSet.use(undefined);
  var t = Translation.useT(/* Common */0);
  return React.createElement(AdLayout.make, {
              children: null
            }, React.createElement(InfoSectionHeader.make, {
                  title: t("Origins")
                }), React.createElement("div", {
                  className: traitsGrid
                }, Belt_Array.map(Sd.allOrigins(set), (function (traitId) {
                        switch (traitId) {
                          case "TFT12_Arcana" :
                              return React.createElement(React.Fragment, {
                                          children: null,
                                          key: traitId
                                        }, React.createElement(TraitInfoCard.make, {
                                              traitId: traitId
                                            }), React.createElement(SupTraits.ArcanaCard.make, {}));
                          case "TFT12_Eldritch" :
                              return React.createElement(React.Fragment, {
                                          children: null,
                                          key: traitId
                                        }, React.createElement(TraitInfoCard.make, {
                                              traitId: traitId
                                            }), React.createElement(SupTraits.EldritchCard.make, {}));
                          case "TFT12_Faerie" :
                              return React.createElement(React.Fragment, {
                                          children: null,
                                          key: traitId
                                        }, React.createElement(TraitInfoCard.make, {
                                              traitId: traitId
                                            }), React.createElement(SupTraits.FaerieCard.make, {}));
                          case "TFT13_JunkerKing" :
                              return React.createElement(React.Fragment, {
                                          children: null,
                                          key: traitId
                                        }, React.createElement(TraitInfoCard.make, {
                                              traitId: traitId
                                            }), React.createElement(SupTraits.JunkerKingCard.make, {}));
                          default:
                            return React.createElement(TraitInfoCard.make, {
                                        traitId: traitId,
                                        key: traitId
                                      });
                        }
                      }))), React.createElement(InfoSectionHeader.make, {
                  title: t("Classes")
                }), React.createElement("div", {
                  className: traitsGrid
                }, Belt_Array.map(Sd.allClasses(set), (function (traitId) {
                        return React.createElement(TraitInfoCard.make, {
                                    traitId: traitId,
                                    key: traitId
                                  });
                      }))));
}

var Inner = {
  make: TraitsInfoPage$Inner
};

function TraitsInfoPage(Props) {
  var set = Props.set;
  return React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(TftSet.fromNum(set), React.createElement(TraitsInfoPage$Inner, {}), undefined));
}

var make = TraitsInfoPage;

export {
  Styles ,
  Inner ,
  make ,
  
}
/* Sd Not a pure module */
